import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { useRef, useEffect, useState } from 'react';
import { testimonials } from '../testimonials';
import Testimonial from '../components/testimonial';

export default function About() {
  const half = Math.ceil(testimonials.length / 2);
  const row1 = testimonials.slice(0, half);
  const row2 = testimonials.slice(half);

  // Refs for scroll containers
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);

  // State to track scroll availability
  const [row1Scroll, setRow1Scroll] = useState({ canLeft: false, canRight: false });
  const [row2Scroll, setRow2Scroll] = useState({ canLeft: false, canRight: false });

  // Card width (should match your Testimonial card's width + margin)
  const CARD_WIDTH = 420; // px, adjust as needed

  const scrollLeft = (ref) => {
    if (ref.current) {
      ref.current.scrollBy({ left: -CARD_WIDTH, behavior: 'smooth' });
    }
  };
  const scrollRight = (ref) => {
    if (ref.current) {
      ref.current.scrollBy({ left: CARD_WIDTH, behavior: 'smooth' });
    }
  };

  // Auto stagger first row when component mounts
  useEffect(() => {
    if (row1Ref.current) {
      row1Ref.current.scrollTo({ left: CARD_WIDTH / 2, behavior: 'auto' });
      updateScrollState(row1Ref, setRow1Scroll);
    }
    if (row2Ref.current) {
      updateScrollState(row2Ref, setRow2Scroll);
    }
  }, []);

  // Update arrow visibility on scroll
  const updateScrollState = (ref, setState) => {
    if (!ref.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = ref.current;
    setState({
      canLeft: scrollLeft > 0,
      canRight: scrollLeft + clientWidth < scrollWidth - 1, // -1 to account for rounding
    });
  };

  // Arrow button style
  const arrowBtnStyle = {
    width: 64,
    height: 64,
    borderRadius: "50%",
    background: "none",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    cursor: "pointer",
    outline: "none",
    padding: 0,
  };

  // Scroll row style
  const scrollRowStyle = {
    display: "flex",
    overflowX: "auto",
    scrollBehavior: "smooth",
    gap: "24px",
    padding: "8px 0",
  };

  return (
    <Container className='about-text text-start work'>
      <Row className='pt-5 mt-5'>
        <Col lg='8'>
          <div className='pb-5'>
            It's so great to e-meet you here! 
          </div>
          <div className='resumelink pb-5'>
            <a href='/img/about/AmberSChenResume.pdf' target="_blank">Resume</a>
          </div>
          <div className='pb-5'>
            I'm a product designer with 6 years of experience shaping accessible, data-informed experiences across AI, B2B, B2C, and SaaS products. 
          </div>
          <div className='pb-5'>
            My work spans AI platforms, public websites, GIS workflows, planning tools, contract and cost tracking, document management, data visualization, client portals, and design systems.
          </div>
          <div className='pb-5'>
            I cut through ambiguity to design clear, scalable solutions that align with user needs, compliance standards, and product direction. From first concept to system growth, I bring order to complexity and focus to innovation.
          </div>
        </Col>
        <Col className='d-flex flex-column justify-content-center'>
          <div className='about-img-container pb-5'>
            <img src='/img/about/profile.jpg' alt='Amber S. Chen' className='about-img' />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className='pt-5 mt-5 pb-3 mb-3 workBold3 text-center'>Testimonials</Col>
      </Row>
      {/* First Row */}
      <div style={{ position: "relative", width: "100%", marginBottom: 32 }}>
        {row1Scroll.canLeft && (
          <button
            onClick={() => scrollLeft(row1Ref)}
            style={{ ...arrowBtnStyle, left: 0 }}
            aria-label="Scroll testimonials left"
          >
            <img src="/img/testimonial_left.png" alt="Left" style={{ width: 48, height: 48 }} />
          </button>
        )}
        {row1Scroll.canRight && (
          <button
            onClick={() => scrollRight(row1Ref)}
            style={{ ...arrowBtnStyle, right: 0 }}
            aria-label="Scroll testimonials right"
          >
            <img src="/img/testimonial_right.png" alt="Right" style={{ width: 48, height: 48 }} />
          </button>
        )}
        <div
          ref={row1Ref}
          style={scrollRowStyle}
          className="hide-scrollbar"
          onScroll={() => updateScrollState(row1Ref, setRow1Scroll)}
        >
          {row1.map((t, idx) => (
            <div key={idx} style={{ minWidth: 400, maxWidth: 400, flex: "0 0 auto" }}>
              <Testimonial testimonial={t} />
            </div>
          ))}
        </div>
      </div>
      {/* Second Row */}
      <div style={{ position: "relative", width: "100%" }}>
        {row2Scroll.canLeft && (
          <button
            onClick={() => scrollLeft(row2Ref)}
            style={{ ...arrowBtnStyle, left: 0 }}
            aria-label="Scroll testimonials left"
          >
            <img src="/img/testimonial_left.png" alt="Left" style={{ width: 48, height: 48 }} />
          </button>
        )}
        {row2Scroll.canRight && (
          <button
            onClick={() => scrollRight(row2Ref)}
            style={{ ...arrowBtnStyle, right: 0 }}
            aria-label="Scroll testimonials right"
          >
            <img src="/img/testimonial_right.png" alt="Right" style={{ width: 48, height: 48 }} />
          </button>
        )}
        <div
          ref={row2Ref}
          style={scrollRowStyle}
          className="hide-scrollbar"
          onScroll={() => updateScrollState(row2Ref, setRow2Scroll)}
        >
          {row2.map((t, idx) => (
            <div key={idx} style={{ minWidth: 400, maxWidth: 400, flex: "0 0 auto" }}>
              <Testimonial testimonial={t} />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
}
